
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stocks/[stockSlug]",
      function () {
        return require("private-next-pages/stocks/[stockSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stocks/[stockSlug]"])
      });
    }
  